import { render, staticRenderFns } from "./Capacity.vue?vue&type=template&id=71832a14&scoped=true&lang=pug&"
import script from "./Capacity.vue?vue&type=script&lang=ts&"
export * from "./Capacity.vue?vue&type=script&lang=ts&"
import style0 from "./Capacity.vue?vue&type=style&index=0&id=71832a14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71832a14",
  null
  
)

export default component.exports